import React from 'react';
import { Flex, Container, Text } from 'basis';
import { ColoredMessage } from 'components/message/ColoredMessage';
import { STEP_CONTACT_DETAILS, STEP_ABOUT_YOU, STEP_VERIFY, STEP_INCOME, STEP_BALANCE_TRANSFER } from '_config';
import { useStoreValue } from 'store';
import { getRatesAndFees } from 'featureToggles';
import LockIcon from 'images/icons/lock.svg';
import HandHeart from 'images/icons/HandHeart.svg';
import SneakerMove from 'images/icons/SneakerMove.svg';
import Files from 'images/icons/Files.svg';
import Swap from 'images/icons/Swap.svg';
import { getProductInfo, isNZ } from 'utils';

const nudgeMessages = {
  [STEP_CONTACT_DETAILS]: {
    icon: HandHeart,
    title: 'You’re in good company!',
    body: () =>
      `Join hundreds and thousands of ${
        isNZ() ? 'New Zealanders' : 'Australians'
      } who are enjoying the benefits from their ${getProductInfo()?.name} credit card`,
  },
  [STEP_ABOUT_YOU]: {
    icon: SneakerMove,
    title: 'Sprint to the completion in no time!',
    body: () => 'On average applicants finish the application process in 10-15 minutes',
  },
  [STEP_VERIFY]: {
    icon: LockIcon,
    title: 'Why verify your mobile?',
    body: () => 'We verify to ensure your application information is securely delivered only to you.',
  },
  verifyEmail: {
    title: 'Why verify your email?',
    body: () => 'We verify to ensure your application information is securely delivered only to you.',
  },
  [STEP_INCOME]: {
    icon: Files,
    title: 'Help us with your credit needs',
    body: () =>
      'Providing your employment and income details helps us assess your financial profile and set your credit limit.',
  },
  [STEP_BALANCE_TRANSFER]: {
    icon: Swap,
    title: 'Balance Transfer',
    body: () =>
      `Reverts to the cash advance rate after the promotional period, currently ${getRatesAndFees()?.cashAnnualRate ||
        29.99}% p.a.`,
  },
};

export const Nudge = ({ title, body }) => {
  const [state] = useStoreValue();
  if (!nudgeMessages[state.activeStep]) {
    return null;
  }
  const nudgeConfig = nudgeMessages[state.activeStep];
  return (
    <ColoredMessage color="stone" borderColor="#F4F3EE">
      <Flex>
        <img src={nudgeConfig?.icon} alt="lock icon" />
        <Container margin="0 0 0 4">
          <Text textStyle="body1" bold="bold" as="h4" color="indigo">
            {title || nudgeConfig?.title}
          </Text>
          <Text textStyle="body2" margin="1 0 0 0" color="indigo">
            {body || nudgeConfig?.body()}
          </Text>
        </Container>
      </Flex>
    </ColoredMessage>
  );
};
